<template>
  <div>
    <BlocoFiltroPesquisa
      nome-do-form="RelatorioHorariosAbertosVsMarcadosForm"
      :botao-adicionar="false"
      @pesquisar="pesquisar"
    >
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
            <SelecionarData
              id="dataBase"
              :valor="filtro.dataBase"
              :validacao="v$.filtro.dataBase"
              label="Data Base"
              @atualizar="filtro.dataBase = $event"
            />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <br />
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import moment from 'moment'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import SelecionarData from '@/componentes/formulario/SelecionarData'
import { useMenu } from '@/composables/useMenu'
import MensagemServico from '@/servicos/MensagemServico'
import RelatorioServico from '@/servicos/RelatorioServico'
const mensagemServico = new MensagemServico()

export default {
  components: {
    BlocoFiltroPesquisa,
    SelecionarData,
  },

  setup() {
    useMenu(64)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      solicitantes: [],
      indicacoes: [],
      totalIndicacoes: 0,
      servico: new RelatorioServico(),
      nomeResultado: 'indicacoes',
      filtro: {
        dataInicio: moment().startOf('month'),
      },
    }
  },
  computed: {
    dataBase() {
      return moment().format('DD/MM/YYYY')
    },
    dataFim() {
      return moment().format('DD/MM/YYYY')
    },
  },
  validations: {
    filtro: {
      dataBase: { required },
    },
  },
  methods: {
    pesquisar() {
      this.v$.$touch()

      if (this.v$.filtro.$invalid) {
        mensagemServico.alerta('Informe a Data Início.')
      } else {
        this.servico
          .relatorioHorariosAbertosVsMarcados(this.filtro)
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'report.xlsx')
            document.body.appendChild(link)
            link.click()
          })
      }
    },
    ordenar(prop) {
      this.filtro.ordenarPor = prop
      this.pesquisar()
    },
  },
}
</script>
